const TemplateFooter = ({ footer, setFooter }) => {
  return (
    <div className="cx-template-section">
      <h5 className="cx-template-section-title">
        <i className="bi bi-type me-2"></i>
        Footer
      </h5>
      
      <div className="mb-3">
        <label className="form-label">Footer Text (Optional)</label>
        <input
          type="text"
          className="form-control"
          value={footer}
          onChange={(e) => setFooter(e.target.value)}
          placeholder="Footer text (max 60 characters)"
          maxLength={60}
        />
        <div className="form-text">{60 - footer.length} characters remaining</div>
      </div>
    </div>
  );
};

export default TemplateFooter;